import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-fn-temporary-resident-banking.component.scss';
var FormItemFnTemporaryResidentBanking = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemFnTemporaryResidentBanking, _super);
    function FormItemFnTemporaryResidentBanking(element) {
        return _super.call(this, element) || this;
    }
    FormItemFnTemporaryResidentBanking.prototype.init = function () {
        this.countryOfOriginSelection = this.element.querySelector('select[name=id-country-of-origin]');
        this.identificationSelection = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
        this.isInSouthAfricaSelection = Array.from(this.element.querySelectorAll('input[name=is-in-south-africa'));
        this.saArrivalDatePicker = this.element.querySelector('.js-date-picker-full');
        this.countryCodeSelect = this.element.querySelector('select[name=country-code-select]');
        this.countryCodeInput = this.element.querySelector('.fn-temporary-resident-banking__code');
        this.phoneNumberInput = this.element.querySelector('input[name=phone-number]');
        this.identificationType = '06';
        this.isInSouthAfrica = 'YES';
        this.formLoader = this.element.querySelector(".form__loader--container");
        this.formFields = this.element.querySelector(".form__fields--container");
        this.formThankyou = this.element.querySelector(".form__thankyou--container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.form = this.element.querySelector('form');
        this.buttonSubmit = this.element.querySelector('.js_step-submit-button');
        this.wizard = this.element.querySelector('.form-container-wizard__wizard');
        var countryOfBirthSelect = this.form.querySelector('select[name=country-of-birth]');
        var countryOfOriginSelect = this.form.querySelector('select[name=id-country-of-origin]');
        var countryCodeSelect = this.form.querySelector('select[name=country-code-select]');
        // Get Json Data
        var countriesJson = '/file_source/assets/mri/cntry.json';
        var countryCodesJson = '/file_source/assets/mri/cntrycodes.json';
        // Set country of birth drop down
        var requestCountries = new XMLHttpRequest();
        requestCountries.open('GET', countriesJson, true);
        requestCountries.onload = function () {
            if (requestCountries.status === 200) {
                var data = JSON.parse(requestCountries.responseText);
                var option = void 0;
                for (var i = 0; i < data.length; i++) {
                    option = document.createElement('option');
                    option.text = data[i].name;
                    option.value = data[i].code;
                    countryOfBirthSelect.add(option);
                }
            }
            else {
                // Error
                console.log("Error");
            }
        };
        requestCountries.onerror = function () {
            console.error('An error occurred fetching the JSON from ' + countriesJson);
        };
        requestCountries.send();
        //Set country of origin drop down
        var requestCountries2 = new XMLHttpRequest();
        requestCountries2.open('GET', countriesJson, true);
        requestCountries2.onload = function () {
            if (requestCountries2.status === 200) {
                var data = JSON.parse(requestCountries2.responseText);
                var option = void 0;
                for (var i = 0; i < data.length; i++) {
                    option = document.createElement('option');
                    option.text = data[i].name;
                    option.value = data[i].code;
                    countryOfOriginSelect.add(option);
                }
            }
            else {
                // Error
                console.log("Error");
            }
        };
        requestCountries2.onerror = function () {
            console.error('An error occurred fetching the JSON from ' + countriesJson);
        };
        requestCountries2.send();
        //Set country codes dropdown
        var requestCountryCodes = new XMLHttpRequest();
        requestCountryCodes.open('GET', countryCodesJson, true);
        requestCountryCodes.onload = function () {
            if (requestCountryCodes.status === 200) {
                var data = JSON.parse(requestCountryCodes.responseText);
                var option = void 0;
                for (var i = 0; i < data.length; i++) {
                    option = document.createElement('option');
                    option.text = data[i].name;
                    option.value = data[i].shortname;
                    option.setAttribute('data-code', data[i].code);
                    countryCodeSelect.add(option);
                }
            }
            else {
                // Error
                console.log("Error");
            }
        };
        requestCountryCodes.onerror = function () {
            console.error('An error occurred fetching the JSON from ' + countryCodesJson);
        };
        requestCountryCodes.send();
        this.updateFormIdPassport(this.identificationType);
        this.updateIsInSouthAfrica(this.isInSouthAfrica);
    };
    FormItemFnTemporaryResidentBanking.prototype.bindEvents = function () {
        var _this = this;
        this.identificationSelection.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            var identificationField = _this.form.querySelector('input[name=identification]');
            _this.identificationType = evt.value;
            if (_this.identificationType === '01') {
                identificationField.classList.remove('form__input--identification--passport');
                identificationField.classList.add('form__input--identification');
                identificationField.placeholder = 'Enter your South African ID number';
                identificationField.value = "";
                identificationField.type = 'number';
            }
            else {
                identificationField.classList.remove('form__input--identification');
                identificationField.classList.add('form__input--identification--passport');
                identificationField.placeholder = 'Enter your Passport number';
                identificationField.value = "";
                identificationField.type = 'text';
            }
            _this.updateFormIdPassport(_this.identificationType);
        }); });
        this.countryCodeSelect.addEventListener('change', function (event) {
            var evtTarget = event.target;
            _this.countryCodeInput.innerHTML = "";
            if (evtTarget.value) {
                _this.countryCodeInput.innerHTML = "+" + evtTarget.options[evtTarget.selectedIndex].getAttribute('data-code');
            }
        });
        this.isInSouthAfricaSelection.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            _this.isInSouthAfrica = evt.value;
            _this.updateIsInSouthAfrica(_this.isInSouthAfrica);
        }); });
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener('click', function (event) {
                _this.saArrivalDatePicker.classList.add("form__input--required");
                var _button = event.target;
                var _form = _button.closest('form');
                var formFields = _form.querySelectorAll('input, select');
                _this.validationService.validate(formFields);
                //Manual Validation for reCaptcha Form Element
                var reCaptchaValid = false;
                var reCaptchaFormField = _form.querySelector('.g-recaptcha');
                var formRecaptchaResponseField = _this.form.querySelector('.g-recaptcha-response');
                reCaptchaValid = (formRecaptchaResponseField.value != null && formRecaptchaResponseField.value != "") ? true : false;
                _this.validationService.validateReCaptcha(reCaptchaValid, reCaptchaFormField);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length == 0 && reCaptchaValid) {
                    _this.submitForm(_form);
                }
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            // allow individual form items components to handle form reset
            if (_this.wizard) {
                var event_1 = new CustomEvent('custom_wizard_reset_event');
                _this.wizard.dispatchEvent(event_1);
            }
            //Recapture Reset
            var gcaptcha = _this.form.querySelectorAll('input[name=g-recaptcha-response]');
            if (gcaptcha) {
                gcaptcha.forEach(function (element) {
                    var newElem = element;
                    newElem.value = "";
                });
            }
            var btnRestartReCaptcha = _this.form.querySelector("a[name=btnRestartReCaptcha]");
            if (btnRestartReCaptcha) {
                btnRestartReCaptcha.click();
            }
        }, false);
    };
    FormItemFnTemporaryResidentBanking.prototype.updateFormIdPassport = function (value) {
        if (this.countryOfOriginSelection) {
            var _countryOfOriginSelectGroup = this.countryOfOriginSelection.closest(".form__group");
            if (value == '01') {
                this.countryOfOriginSelection.classList.remove("form__input--required");
                _countryOfOriginSelectGroup.classList.add('form__group--hidden');
            }
            else {
                _countryOfOriginSelectGroup.classList.remove('form__group--hidden');
                this.countryOfOriginSelection.classList.add("form__input--required");
            }
        }
    };
    FormItemFnTemporaryResidentBanking.prototype.updateIsInSouthAfrica = function (value) {
        if (this.isInSouthAfricaSelection.length > 0 && this.saArrivalDatePicker) {
            var _datePickerSelectGroup = this.saArrivalDatePicker.closest(".form__group");
            var _isInSouthAfricaSelectionGroup = this.isInSouthAfricaSelection[0].closest(".form__group");
            if (_datePickerSelectGroup && _isInSouthAfricaSelectionGroup) {
                if (value == 'YES') {
                    this.saArrivalDatePicker.classList.remove("form__input--required");
                    _datePickerSelectGroup.classList.add('form__group--hidden');
                    _isInSouthAfricaSelectionGroup.setAttribute('style', 'padding: 0 0 25px 0;');
                }
                else {
                    _datePickerSelectGroup.classList.remove('form__group--hidden');
                    this.saArrivalDatePicker.classList.remove("form__input--required");
                    _isInSouthAfricaSelectionGroup.setAttribute('style', 'padding: 0 0 15px 0;');
                }
            }
        }
    };
    FormItemFnTemporaryResidentBanking.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        var name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var postData = '';
        var serviceType = form.querySelector("input[name=service-type]");
        if (serviceType) {
            postData += "&service-type=" + serviceType.value;
        }
        var description = form.querySelector("input[name=description]");
        if (description) {
            postData += "&description=" + description.value;
        }
        var email = form.querySelector("input[name=email]");
        if (email) {
            postData += "&email=" + email.value;
        }
        var recipient = form.querySelector("input[name=recipient]");
        if (recipient) {
            postData += "&recipient=" + recipient.value;
        }
        var subject = form.querySelector("input[name=subject]");
        if (subject) {
            postData += "&subject=" + subject.value;
        }
        var product = form.querySelector("input[name=product]");
        if (product) {
            postData += "&productName=" + product.value;
        }
        var redirect = form.querySelector("input[name=redirect]");
        if (redirect) {
            postData += "&redirect=" + redirect.value;
        }
        var _nameTitle = this.form.querySelector('select[name=name-title]');
        if (_nameTitle) {
            postData += "&namePrefix=" + _nameTitle.value;
        }
        var _firstname = this.form.querySelector('input[name=first-name]');
        if (_firstname) {
            postData += "&firstname=" + _firstname.value;
        }
        var _surname = this.form.querySelector('input[name=last-name]');
        if (_surname) {
            postData += "&surname=" + _surname.value;
        }
        var _identificationType = this.identificationType;
        if (_identificationType) {
            postData += "&idType=" + _identificationType;
        }
        var _identificationNumber = this.form.querySelector('input[name=identification]');
        if (_identificationNumber) {
            postData += "&idNumber=" + _identificationNumber.value;
        }
        if (_identificationType) {
            if (_identificationType == "06") {
                var _idCountryOfOrigin = this.form.querySelector('select[name=id-country-of-origin]');
                if (_idCountryOfOrigin) {
                    postData += "&idCountryCd=" + _idCountryOfOrigin.value;
                }
            }
            else if (_identificationType == "01") {
                postData += "&idCountryCd=ZA";
            }
            else {
                postData += "&idCountryCd=";
            }
        }
        var _countryOfBirth = this.form.querySelector('select[name=country-of-birth]');
        if (_countryOfBirth) {
            postData += "&birthCountryCd=" + _countryOfBirth.value;
        }
        var _countryCode = this.form.querySelector('select[name=country-code-select]');
        if (_countryCode) {
            postData += "&phoneCountryCd=" + _countryCode.value;
        }
        var _contactNumber = this.form.querySelector('input[name=phone-number]');
        if (_contactNumber) {
            postData += "&contact=" + _contactNumber.value;
        }
        var _emailAddress = this.form.querySelector('input[name=email-address]');
        if (_emailAddress) {
            postData += "&emailAddress=" + _emailAddress.value;
        }
        var _isInSouthAfrica = this.isInSouthAfrica;
        if (_isInSouthAfrica) {
            postData += "&in-SouthAfrica=" + _isInSouthAfrica;
        }
        if (_isInSouthAfrica == "YES") {
            postData += "&expected-Arrival-Date=";
        }
        else {
            var _expectedDateOfArrival = this.element.querySelector('.js-date-picker-full');
            if (_expectedDateOfArrival) {
                postData += "&expected-Arrival-Date=" + _expectedDateOfArrival.value;
            }
        }
        var _fraudCheckConsent = this.form.querySelector('input[name=fraud-check-consent]');
        if (_fraudCheckConsent) {
            postData += "&consent=" + 'YES';
        }
        var _formRecaptchaResponse = this.form.querySelector('input[name=g-recaptcha-response]');
        if (_formRecaptchaResponse) {
            postData += "&g-recaptcha-response=" + _formRecaptchaResponse.value;
        }
        // loader + hide form
        this.formLoader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/foreignnationalsservice.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            loader.classList.remove('active');
            if (!response.data || (response.data.toString().includes('invalid'))
                || (response.data.toString().includes('error')) || response.data['success'].toString() == 'false') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                thankYou.classList.add('active');
                success.classList.remove('active');
                success.classList.add('hidden');
                error.classList.remove('hidden');
                error.classList.add('active');
            }
            else {
                if (response.code) {
                    analyticsService.dtmFormComplete('complete', response.code);
                }
                else if (response.status) {
                    analyticsService.dtmFormComplete('complete', response.status);
                }
                else {
                    analyticsService.dtmFormComplete('complete', "200");
                }
                thankYou.classList.add('active');
                error.classList.remove('active');
                error.classList.add('hidden');
                success.classList.remove('hidden');
                success.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
        this.resetForm();
    };
    FormItemFnTemporaryResidentBanking.prototype.resetForm = function () {
        this.identificationType = '06';
        this.isInSouthAfrica = 'YES';
        var identificationField = this.form.querySelector('input[name=identification]');
        identificationField.classList.remove('form__input--identification');
        identificationField.classList.add('form__input--identification--passport');
        identificationField.placeholder = 'Enter your Passport number';
        identificationField.value = "";
        identificationField.type = 'text';
        this.countryCodeInput.innerHTML = "";
        var formRecaptchaResponseFields = this.form.querySelectorAll('input[name=g-recaptcha-response]');
        formRecaptchaResponseFields.forEach(function (element) {
            var newElem = element;
            newElem.value = "";
        });
        var btnRestartReCaptcha = this.form.querySelector("a[name=btnRestartReCaptcha]");
        if (btnRestartReCaptcha) {
            btnRestartReCaptcha.click();
        }
        this.updateFormIdPassport(this.identificationType);
        this.updateIsInSouthAfrica(this.isInSouthAfrica);
    };
    return FormItemFnTemporaryResidentBanking;
}(Base));
export { FormItemFnTemporaryResidentBanking };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-fn-temporary-resident-banking/form-item-fn-temporary-resident-banking.component.ts
// module id = 909
// module chunks = 0